import { Icon } from "@iconify/react";
import { UploadedFileType } from "../utils/constants";

interface FileUploadProps {
    file: UploadedFileType;
}

const FileUpload = (props: FileUploadProps) => {
    const { file } = props;
    return (
        <div className="flex items-center gap-1 border-1 rounded-md p-1 w-full relative">
            <div className="relative">
                <Icon icon="circum:file-on" width="2.8em" height="3.5em" style={{ color: "#D5D7DA" }} />
                <span className="text-[8px] bg-danger px-1 rounded-sm text-[#fff] absolute bottom-4 left-1">{file?.type}</span>
            </div>
            <div className='flex flex-col'>
                {(() => {
                    let displayName;
                    if(file?.uploading) {
                        displayName = 'Uploading...';
                    } else if (file?.name?.length > 20) {
                        displayName = file?.name;
                    } else {
                        displayName = file?.name;
                    }
                    return <span className="font-medium text-[11px]">{displayName?.toUpperCase()}{" "}</span>;
                })()}
                <span className="text-[10px] text-default-400 font-normal">{file?.size}</span>
            </div>
        </div>
    );
};

export { FileUpload };